<template>
  <div>
    <select-entity-combobox
      :events="[event]"
      :cardIds="[query.id]"
      :style="{
        '--borderColor': query.isInContext ? cardTypeColor(queryCardType) : '#868686',
        '--borderTopWidth': '1px'
      }"
      class="mb-1"
    />
    <v-textarea
      v-if="!!query.entityId"
      :ref="(el) => emit('getTextareaRef', el)"
      auto-grow
      rows="2"
      variant="outlined"
      density="compact"
      placeholder="Description"
      hide-details="auto"
      :model-value="descriptions?.[event.index]?.[queryIndex] || ''"
      @update:model-value="desc => {
        const key = `${event.index}-${queryIndex}`
        descriptions[event.index][queryIndex] = desc
        emit('updateTextareaHeight')
      }"
      @blur="() => emit('updateDescription', query, descriptions[event.index][queryIndex])"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import SelectEntityCombobox from '@/components/SelectEntityCombobox.vue'
import useDomainModel from '@/composables/useDomainModel'
import { diagramHelpers } from '@/mixins/diagramHelpers'

const store = useStore()
const requirementTypes = computed(() => store.state.requirementTypes.requirementTypes)
const queryCardType = computed(() => diagramHelpers.methods.getQueryCardType(requirementTypes.value))

const {
  event,
  query,
  queryIndex,
  descriptions
} = defineProps({
  event: Object,
  query: Object,
  queryIndex: Number,
  descriptions: Array
})
const emit = defineEmits(['updateTextareaHeight', 'updateDescription', 'getTextareaRef'])

const { cardTypeColor } = useDomainModel()
</script>
